module.exports = __webpack_public_path__ + "static/media/dashboard.d3e66098.svg";